import type { Notification } from './api'

export function getNotificationLink(notif: Notification): string | null {
  const data = notif.data || {}
  const appName = data.app_name as string | undefined
  const appPath = appName ? `/apps/${encodeURIComponent(appName)}` : null

  switch (notif.type) {
    case 'app_shared':
    case 'access_approved':
      return appPath ?? '/apps?tab=shared'
    // Public-access lifecycle: all three land on the app detail page so an
    // admin sees the pending request inline (mirrors the owner-side
    // access_requests UX), and a requester lands on their own app's page to
    // see the approved/rejected state.
    case 'app_error':
    case 'other_app_errors':
    case 'app_auto_stopped':
    case 'production_build_triggered':
    case 'production_build_success':
    case 'production_build_failed':
    case 'other_app_published':
    case 'new_public_app':
    case 'access_request':
    case 'public_access_requested':
    case 'public_access_approved':
    case 'public_access_rejected':
      return appPath
    case 'claude_awaiting_input':
    case 'claude_task_complete':
      return appName ? `/workspace?app=${encodeURIComponent(appName)}` : null
    case 'new_feedback':
    case 'feedback_comment':
    case 'feedback_status':
      return '/feedback'
    case 'new_user_registered':
      return '/admin/users'
    case 'secret_scan_finding':
      return '/admin/secret-findings'
    case 'changelog_released':
      return '/changelog'
    case 'ownership_transfer_request': {
      const transferId = data.transfer_id
      return typeof transferId === 'number' || typeof transferId === 'string'
        ? `/apps?incoming-transfer=${encodeURIComponent(String(transferId))}`
        : '/apps?tab=shared'
    }
    case 'ownership_transfer_responded':
      return appPath ?? '/apps'
    default:
      return null
  }
}
